import { all, call, put, takeEvery } from "redux-saga/effects";
import * as api from "../constants/api";

// Import your Redux action constants
import {
  ROOM_LOADING,
  CHAT_LIST_LOADING,
  CHAT_ROOM_LOADING,
  GET_CHAT_ROOM,
  SG_GET_CHAT_ROOM_V2,
  CREATE_CHAT_ROOM_V2,
  SG_CREATE_CHAT_ROOM_V2,
  DELETE_CHAT_ROOM,
  SG_DELETE_CHAT_ROOM,
  FETCH_CHAT_ROOM_V2,
  ALL_ERRORS,
  SG_FETCH_CHAT_ROOM_V2,
} from "../constants/actions";

// ============ 1) GET multiple chat rooms ============
function* getProcess(action) {
  // This is like fetchChatRoomsSaga
  yield put({ type: ROOM_LOADING });
  yield put({ type: CHAT_LIST_LOADING });
  try {
    // Calls the API to get a list of all rooms
    const response = yield call(api.GET_CHAT_ROOMS_V2, action.payload);
    // On success, dispatch GET_CHAT_ROOM
    yield put({ type: GET_CHAT_ROOM, payload: response.data });
  } catch (error) {
    // On failure, dispatch ALL_ERRORS
    yield put({ type: ALL_ERRORS, payload: error.message });
  }
}

function* getSaga() {
  // We “takeEvery” SG_GET_CHAT_ROOM, then run getProcess
  yield takeEvery(SG_GET_CHAT_ROOM_V2, getProcess);
}

// ============ 2) FETCH details for a specific chat room ============
function* fetchProcess(action) {
  // This is like fetchChatRoomDetailsSaga
  yield put({ type: ROOM_LOADING });
  yield put({ type: CHAT_ROOM_LOADING });
  try {
    // Calls the API to get details of one specific room
    const response = yield call(api.FETCH_CHAT_ROOM_V2, action.payload);
    // On success, dispatch FETCH_CHAT_ROOM
    yield put({ type: FETCH_CHAT_ROOM_V2, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.message });
  }
}

function* fetchSaga() {
  // We “takeEvery” SG_FETCH_CHAT_ROOM, then run fetchProcess
  yield takeEvery(SG_FETCH_CHAT_ROOM_V2, fetchProcess);
}

// ============ 3) CREATE a chat room ============
function* createProcess(action) {
  yield put({ type: ROOM_LOADING });
  try {
    // Extract initial_message and other payload data
    const { initial_message, ...payload } = action.payload;
    const response = yield call(api.CREATE_CHAT_V2, payload);
    // Pass initial_message as pendingInitialMessage
    yield put({
      type: CREATE_CHAT_ROOM_V2,
      payload: response.data,
      pendingInitialMessage: initial_message, // Extract message from initial_message
    });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.message });
  }
}

function* createSaga() {
  yield takeEvery(SG_CREATE_CHAT_ROOM_V2, createProcess);
}

// ============ 4) DELETE a chat room ============
function* deleteProcess(action) {
  yield put({ type: ROOM_LOADING });
  try {
    // Note: rename “api.DELETE_CHAT_ROOM” → “api.deleteChatRoom”
    yield call(api.DELETE_CHAT_ROOM_V2, action.payload);
    yield put({ type: DELETE_CHAT_ROOM, payload: action.payload });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.message });
  }
}

function* deleteSaga() {
  yield takeEvery(SG_DELETE_CHAT_ROOM, deleteProcess);
}

// ============ Root Saga ============
export default function* rootSaga() {
  yield all([
    getSaga(), // GET all rooms
    fetchSaga(), // FETCH details of a single room
    createSaga(),
    deleteSaga(),
  ]);
}
